import { render, staticRenderFns } from "./DeveloperTokens.vue?vue&type=template&id=11596506&scoped=true&"
import script from "./DeveloperTokens.vue?vue&type=script&lang=js&"
export * from "./DeveloperTokens.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperTokens.vue?vue&type=style&index=0&id=11596506&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11596506",
  null
  
)

export default component.exports